"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");require("core-js/modules/es6.array.find");Object.defineProperty(exports, "__esModule", { value: true });exports.parseTime = parseTime;exports.formatTime = formatTime;exports.getQueryObject = getQueryObject;exports.byteLength = byteLength;exports.cleanArray = cleanArray;exports.param = param;exports.param2Obj = param2Obj;exports.html2Text = html2Text;exports.objectMerge = objectMerge;exports.toggleClass = toggleClass;exports.getTime = getTime;exports.debounce = debounce;exports.deepClone = deepClone;exports.uniqueArr = uniqueArr;exports.createUniqueString = createUniqueString;exports.hasClass = hasClass;exports.addClass = addClass;exports.removeClass = removeClass;exports.isOversea = isOversea;exports.deviceRegionList = deviceRegionList;exports.reorganizeFile = reorganizeFile;exports.readZipTargetFile = readZipTargetFile;exports.readZipHtmlFile = readZipHtmlFile;require("core-js/modules/es6.string.ends-with");require("core-js/modules/es7.array.includes");require("core-js/modules/es6.string.includes");require("core-js/modules/es7.symbol.async-iterator");require("core-js/modules/es6.symbol");require("core-js/modules/es6.function.name");require("core-js/modules/es6.string.starts-with");require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));require("core-js/modules/es6.regexp.constructor");require("core-js/modules/es6.regexp.match");require("core-js/modules/es6.set");require("core-js/modules/es6.string.iterator");require("core-js/modules/es6.array.from");require("core-js/modules/es6.regexp.split");require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.object.keys");require("core-js/modules/es7.string.pad-start");require("core-js/modules/es6.regexp.replace");require("core-js/modules/es6.regexp.to-string");var _typeof2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/typeof"));


var _jszip = _interopRequireDefault(require("jszip"));
var _lodash = require("lodash"); /**
                                  * Created by PanJiaChen on 16/11/18.
                                  */




function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if ((0, _typeof2.default)(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay() };

  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {return ['日', '一', '二', '三', '四', '五', '六'][value];}
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
   * @param {number} time
   * @param {string} option
   * @returns {string}
   */
function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分');

  }
}

/**
   * @param {string} url
   * @returns {Object}
   */
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
   * @param {string} input value
   * @returns {number} output value
   */
function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else
    if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}

/**
   * @param {Array} actual
   * @returns {Array}
   */
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
   * @param {Object} json
   * @returns {Array}
   */
function param(json) {
  if (!json) return '';
  return cleanArray(
  Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).
  join('&');
}

/**
   * @param {string} url
   * @returns {Object}
   */
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
  '{"' +
  decodeURIComponent(search).
  replace(/"/g, '\\"').
  replace(/&/g, '","').
  replace(/=/g, '":"').
  replace(/\+/g, ' ') +
  '"}');

}

/**
   * @param {string} val
   * @returns {string}
   */
function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
   * Merges two objects, giving the last one precedence
   * @param {Object} target
   * @param {(Object|Array)} source
   * @returns {Object}
   */
function objectMerge(target, source) {
  if ((0, _typeof2.default)(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if ((0, _typeof2.default)(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
   * @param {HTMLElement} element
   * @param {string} className
   */
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString =
    classString.substr(0, nameIndex) +
    classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
   * @param {string} type
   * @returns {Date}
   */
function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
   * @param {Function} func
   * @param {number} wait
   * @param {boolean} immediate
   * @return {*}
   */
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;

  var later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function () {for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
   * This is just a simple version of deep copy
   * Has a lot of edge cases bug
   * If you want to use a perfect deep copy, use lodash's _.cloneDeep
   * @param {Object} source
   * @returns {Object}
   */
function deepClone(source) {
  if (!source && (0, _typeof2.default)(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && (0, _typeof2.default)(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
   * @param {Array} arr
   * @returns {Array}
   */
function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
   * @returns {string}
   */
function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
   * Check if an element has a class
   * @param {HTMLElement} elm
   * @param {string} cls
   * @returns {boolean}
   */
function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
   * Add class to element
   * @param {HTMLElement} elm
   * @param {string} cls
   */
function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
   * Remove class from element
   * @param {HTMLElement} elm
   * @param {string} cls
   */
function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

function isOversea() {
  return process.env.VUE_APP_OG_ENV == 'americaDevelopment' || process.env.VUE_APP_OG_ENV == 'asiaProduction' || process.env.VUE_APP_OG_ENV == 'americaProduction';
}

function deviceRegionList() {
  var list = [];
  if (isOversea()) {
    list = [{ id: 1, name: '美洲区' }, { id: 2, name: '亚洲区' }];
  } else {
    list = [{ id: 1, name: '国内' }];
  }
  return list;
}

function reorganizeFile(file, path, newName) {
  return new Promise( /*#__PURE__*/function () {var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {var ab, oldZip, newZip, fileKeys, nameFileKeys, realFileName, _i, _fileKeys, fileName, _file, newFilePath, nameList, content, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _fileName, _file2, tempList, _nameList, blob, newFile;return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                readFileAsAB(file));case 2:ab = _context.sent;_context.next = 5;return (
                _jszip.default.loadAsync(ab));case 5:oldZip = _context.sent;
              newZip = new _jszip.default();
              fileKeys = Object.keys(oldZip.files);
              nameFileKeys = Object.keys(oldZip.files).filter(function (name) {
                return !name.startsWith('_MACOSX') && !oldZip.files[name].dir && !name.startsWith('__MACOSX');
              });
              realFileName = '';
              console.log('fileKeys======>', fileKeys);_i = 0, _fileKeys =
              fileKeys;case 12:if (!(_i < _fileKeys.length)) {_context.next = 29;break;}fileName = _fileKeys[_i];
              _file = oldZip.files[fileName];
              newFilePath = path + _file.name;
              console.log('newFilePath=====>', newFilePath, _file.name);
              if (fileKeys.length == 1) {
                nameList = _file.name.split('/');
                realFileName = nameList[nameList.length - 1];
              }if (!
              _file.dir) {_context.next = 22;break;}
              newZip.folder(newFilePath);_context.next = 26;break;case 22:_context.next = 24;return (

                _file.async('uint8array'));case 24:content = _context.sent;
              newZip.file(newFilePath, content);case 26:_i++;_context.next = 12;break;case 29:_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;_context.prev = 32;


              for (_iterator = nameFileKeys[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {_fileName = _step.value;
                _file2 = oldZip.files[_fileName];
                // const newFilePath = 'osakiHome/8638A-TITVD/' + file.name
                tempList = _file2.name.split('/');
                if (nameFileKeys.length == 1) {
                  _nameList = _file2.name.split('/');
                  realFileName = _nameList[_nameList.length - 1];
                }
              }_context.next = 40;break;case 36:_context.prev = 36;_context.t0 = _context["catch"](32);_didIteratorError = true;_iteratorError = _context.t0;case 40:_context.prev = 40;_context.prev = 41;if (!_iteratorNormalCompletion && _iterator.return != null) {_iterator.return();}case 43:_context.prev = 43;if (!_didIteratorError) {_context.next = 46;break;}throw _iteratorError;case 46:return _context.finish(43);case 47:return _context.finish(40);case 48:_context.next = 50;return (
                newZip.generateAsync({ type: 'blob', compression: 'DEFLATE' }));case 50:blob = _context.sent;
              newFile = new File([blob], "".concat(newName, ".zip"), { type: 'application/zip' });
              resolve([newFile, realFileName]);case 53:case "end":return _context.stop();}}}, _callee, null, [[32, 36, 40, 48], [41,, 43, 47]]);}));return function (_x, _x2) {return _ref.apply(this, arguments);};}());

}

function readZipTargetFile(file) {
  return new Promise( /*#__PURE__*/function () {var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {var ab, contents, targetFilePath, txt, firstLine;return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
                readFileAsAB(file));case 2:ab = _context2.sent;_context2.next = 5;return (
                _jszip.default.loadAsync(ab));case 5:contents = _context2.sent;
              targetFilePath = 'udata/config.txt';
              console.log('exist=====>', contents.files[targetFilePath]);if (
              contents.files[targetFilePath]) {_context2.next = 11;break;}
              reject('config.txt文件不存在');return _context2.abrupt("return");case 11:_context2.next = 13;return (


                contents.file(targetFilePath).async('string'));case 13:txt = _context2.sent;
              firstLine = txt.split(/\r?\n/)[0].trim();
              resolve(firstLine);case 16:case "end":return _context2.stop();}}}, _callee2);}));return function (_x3, _x4) {return _ref2.apply(this, arguments);};}());

}

function readZipHtmlFile(file) {
  return new Promise( /*#__PURE__*/function () {var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {var ab, contents, hasHtmlInRoot;return regeneratorRuntime.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (
                readFileAsAB(file));case 2:ab = _context3.sent;_context3.next = 5;return (
                _jszip.default.loadAsync(ab));case 5:contents = _context3.sent;
              // const targetFilePath = './index.html'
              // console.log('exist=====>', contents.files[targetFilePath])
              // if (!contents.files[targetFilePath]) {
              //   reject(false)
              //   return
              // }
              // let hasHtmlInRoot = Object.keys(contents.files).some(filePath => {
              //   console.log('some=========>', filePath)
              //   !filePath.includes('/') && filePath.toLowerCase().endsWith('.html')
              // })
              hasHtmlInRoot = (0, _lodash.find)(Object.keys(contents.files), function (filePath) {
                return !filePath.includes('/') && filePath.toLowerCase().endsWith('.html');
              });
              if (!hasHtmlInRoot) {
                reject(false);
              } else {
                resolve(hasHtmlInRoot);
              }case 8:case "end":return _context3.stop();}}}, _callee3);}));return function (_x5, _x6) {return _ref3.apply(this, arguments);};}());

}

function readFileAsAB(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {return resolve(reader.result);};
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}